import { FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup, Stack, Typography, useMediaQuery } from '@mui/material'
import { FunctionComponent, SetStateAction } from 'react'
import gaiaTheme from '../../../../root-components/theme'
import FormEditButtons from './form-edit-buttons';

export const FormRadioInputDisplay: FunctionComponent<{
  isEditPage: boolean,
  allowEdit?: boolean,
  editField?: string | undefined,
  setEditField?: React.Dispatch<SetStateAction<any>> | undefined,
  disabled: boolean,
  isLastField?: boolean,
  title: string,
  name: string,
  value: string | number | undefined,
  touched?: any,
  errors?: any,
  onChange: any,
  // Either supply `options` (any number of choices) or the legacy optionOne*/optionTwo* pair.
  // `options` takes precedence when provided.
  options?: { value: string | boolean, label: string }[],
  optionOneValue?: string | boolean,
  optionOneLabel?: string,
  optionTwoValue?: string | boolean,
  optionTwoLabel?: string,
  cancelEditHandler?: () => void,
  hideEditIcon?: boolean,
  customErrorMessage?: string,
  bottomBorder?: boolean,
  topBorder?: boolean,
  sideBorders?: boolean,
  isTopRow?: boolean,
  isBottomRow?: boolean,
  row?: boolean,
}> = ({
  isEditPage,
  allowEdit = true,
  editField,
  setEditField,
  disabled,
  isLastField = false,
  hideEditIcon = false,
  title,
  value,
  name,
  touched,
  errors,
  onChange,
  options,
  optionOneValue,
  optionOneLabel,
  optionTwoValue,
  optionTwoLabel,
  cancelEditHandler,
  customErrorMessage,
  bottomBorder = false,
  topBorder = true,
  sideBorders = true,
  isTopRow = false,
  isBottomRow = false,
  row = false,
}) => {

    const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('md'));

    const toggleEditField = (fieldName: string) => {
      if (setEditField) {
        setEditField(fieldName)
      }
    }

    return (
      <FormControl fullWidth variant='outlined'>
        <Stack sx={{
          borderWidth: '1px',
          borderBottomStyle: bottomBorder || isBottomRow ? 'solid' : 'none',
          borderColor: 'lightGrey.main',
          borderLeftStyle: sideBorders ? 'solid' : 'none',
          borderRightStyle: sideBorders ? 'solid' : 'none',
          borderTopStyle: topBorder || isTopRow ? 'solid' : 'none',
          pt: 1, pb: 1, pl: 3,
          borderTopLeftRadius: isTopRow ? '10px' : 0,
          borderTopRightRadius: isTopRow ? '10px' : 0,
          borderBottomLeftRadius: isBottomRow ? '10px' : 0,
          borderBottomRightRadius: isBottomRow ? '10px' : 0
        }}>
          <Stack position='relative' alignItems={isMobileMode ? 'flex-start' : 'center'} flexDirection={isMobileMode ? 'column' : 'row'} justifyContent='start'>
            <Typography variant='subtitle1' sx={{ width: isMobileMode ? '100%' : '40%', minWidth: '100px', color: 'text.primary' }}> {title} </Typography>
            <Stack position='relative' flexDirection='column' sx={{ width: '100%' }}>
              <Stack position='relative' flexDirection='row' justifyContent='start' alignItems='center'>
                <RadioGroup
                  row={row}
                  onChange={onChange}
                  value={value}
                  id={name} name={name}
                  sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: row ? 'row' : 'column',
                    flexWrap: row ? 'wrap' : 'nowrap',
                    gap: row ? 2 : 0,
                    mt: 1, mb: 1, mr: row ? 1 : 15, ml: 4,
                    ...((editField !== name || isEditPage) && {
                      '& .MuiOutlinedInput-notchedOutline': { border: 'none' }
                    }),
                    ...((editField === name || !isEditPage) && {
                      '& .MuiOutlinedInput-notchedOutline': { borderColor: 'text.secondary' }
                    }),
                    ...(!isEditPage && {
                      mt: 1, mb: 1, mr: 1, ml: 2,
                    }), color: 'text.secondary'
                  }}>

                  {(options ?? [
                    { value: optionOneValue as string | boolean, label: optionOneLabel as string },
                    { value: optionTwoValue as string | boolean, label: optionTwoLabel as string },
                  ]).map((option) => (
                    <FormControlLabel key={String(option.value)} value={option.value} control={<Radio disabled={disabled} />} label={option.label} />
                  ))}
                </RadioGroup>
                {allowEdit &&
                  <FormEditButtons
                    isEditPage={isEditPage}
                    editField={editField}
                    hideEditIcon={hideEditIcon}
                    name={name}
                    toggleEditField={toggleEditField}
                    cancelEditHandler={cancelEditHandler}
                  />}
              </Stack>
              {touched && errors &&
                <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
                  {errors ? <div>{errors as string}</div> : null}
                </FormHelperText>
              }
              {customErrorMessage &&
                <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>{customErrorMessage}
                </FormHelperText>
              }
            </Stack>
          </Stack>
        </Stack>
      </FormControl>
    )
  }